'use strict';

var googleRecaptcha = require('int_google/googleRecaptcha');

/**
 * Validates an email address format
 * @param {string} email - email address to validate
 * @returns {boolean} true if the email is valid
 */
function isValidEmail(email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    var status;
    if (data.success) {
        status = 'alert-custom-success';
    } else {
        status = 'alert-custom-danger';
    }

    if ($('.email-signup-message-text').length === 0) {
        $('.email-subscription-feedback-container').append(
            '<p class="email-signup-message-text text-center font-size-14px"></p>'
        );
    }
    $('.email-signup-message-text').html('<span class="' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message-text').remove();
        var $form = $('form.subscribe-newsletter');
        var radioSelected = $form.find('input[name="customerType"]:checked').length > 0;
        var emailValue = $form.find('input[name="email"]').val().trim();
        var emailValid = emailValue !== '' && isValidEmail(emailValue);
        var termsChecked = $form.find('input[name="termsAndConditions"]').is(':checked');
        var privacyChecked = $form.find('input[name="privacyPolicy"]').is(':checked');
        if (radioSelected && emailValid && termsChecked && privacyChecked) {
            button.removeAttr('disabled');
        }
    }, 5000);
}

module.exports = function () {
    var $form = $('form.subscribe-newsletter');
    var $subscribeBtn = $form.find('.btn-subscribe');

    /**
     * Toggles the subscribe button based on the form inputs
     */
    function toggleSubscribeButton() {
        var radioSelected = $form.find('input[name="customerType"]:checked').length > 0;
        var emailValue = $form.find('input[name="email"]').val().trim();
        var emailValid = emailValue !== '' && isValidEmail(emailValue);
        var termsChecked = $form.find('input[name="termsAndConditions"]').is(':checked');
        var privacyChecked = $form.find('input[name="privacyPolicy"]').is(':checked');

        if (radioSelected && emailValid && termsChecked && privacyChecked) {
            $subscribeBtn.removeAttr('disabled');
        } else {
            $subscribeBtn.attr('disabled', true);
        }
    }

    $form.on('change', 'input[name="customerType"], input[name="termsAndConditions"], input[name="privacyPolicy"]', toggleSubscribeButton);
    $form.on('input', 'input[name="email"]', toggleSubscribeButton);

    $('form.subscribe-newsletter').submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var button = $('.subscribe-newsletter');
        var url = form.attr('action');
        form.spinner().start();
        button.attr('disabled', true);
        (googleRecaptcha.getRecaptchaToken()).then((recaptchaTokenData) => {
            if (recaptchaTokenData && recaptchaTokenData.success) {
                let formData = form.serialize();
                formData = formData + '&recaptchaToken=' + recaptchaTokenData.recaptchaToken;
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: formData,
                    success: function (data) {
                        if (data.recaptchaError) {
                            if (data.recaptchErrorMsg) {
                                displayMessage({ success: false, msg: data.recaptchErrorMsg }, button);
                            }
                            form.spinner().stop();
                            return;
                        }
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else {
                            displayMessage(data, button);
                            form.spinner().stop();
                        }
                    },
                    error: function (err) {
                        displayMessage(err, button);
                        form.spinner().stop();
                    }
                });
            } else {
                form.spinner().stop();
                button.removeAttr('disabled');
            }
        }).catch(function (error) {
            form.spinner().stop();
            if (error && error.errorMsg) {
                displayMessage({ success: false, msg: error.errorMsg }, button);
            }
        });
    });

    /**
     * Handle checkout footer link clicks to load content in modal
     */
    $(document).on('click', 'a.checkout-footer-link', function (e) {
        e.preventDefault();
        var $link = $(this);
        var href = $link.data('href');

        if (!href) {
            // If no data-href, use regular href
            var regularHref = $link.attr('href');
            var urlParams = new URL(regularHref).searchParams;
            var isPopUp = urlParams.get('isPopUp');

            if (regularHref && regularHref !== '#' && (isPopUp === false || isPopUp === 'false' || isPopUp === null)) {
                window.location.href = regularHref;
            }
        } else {
            $.spinner().start();
        }

        var $modal = $('#checkoutFooterModal');
        var $modalBody = $modal.find('.modal-body');

        $.ajax({
            url: href,
            type: 'GET',
            dataType: 'html',
            success: function (data) {
                let htmlContent = data;
                let tempContent = $(data).find('#maincontent');
                if (tempContent.length > 0) {
                    htmlContent = tempContent.html();
                }
                $modalBody.html(htmlContent);
                $modal.modal('show');
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};
